import { render, staticRenderFns } from "./ProductType.vue?vue&type=template&id=f5838658&scoped=true"
import script from "./ProductType.vue?vue&type=script&lang=js"
export * from "./ProductType.vue?vue&type=script&lang=js"
import style0 from "./ProductType.vue?vue&type=style&index=0&id=f5838658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5838658",
  null
  
)

export default component.exports